export default __webpack_public_path__ + "static/media/task-type-estimation-legend.5b2c8ebe.svg";